import React, {Component} from 'react';
import './TestimonialsSection.css';
import {
  FaAmazon,
  FaInstagram,
  FaTwitter,
  FaFacebook
} from 'react-icons/fa'
import $ from 'jquery';
import testimonialsRc from 'assets/images/awair/testimonials-recode.png';
import testimonialsNbc from 'assets/images/awair/testimonials-nbcnews.png';
import testimonialsCnet from 'assets/images/awair/testimonials-cnet.png';
import testimonialsYa from 'assets/images/awair/testimonials-yahoo.png';
import testimonialsBr from 'assets/images/awair/testimonials-britco.png';
import testimonialsTc from 'assets/images/awair/testimonials-tc.png';
import testimonialsPsfk from 'assets/images/awair/testimonials-psfk.png';
import testimonialsVb from 'assets/images/awair/testimonials-venturebeat.png';
import testimonialsEn from 'assets/images/awair/testimonials-engadget.png';
import testimonialsDw from 'assets/images/awair/testimonials-dwell.png';
import testimonialsZen from 'assets/images/awair/testimonials-zendesk.png';
import testimonialsFa from 'assets/images/awair/testimonials-fatherly.png';
import testimonialsLh from 'assets/images/awair/testimonials-lifehacker.png';
import testimonialsDm from 'assets/images/awair/testimonials-designmilk.png';
import testimonialsWt from 'assets/images/awair/testimonials-washtimes.png';

class TestimonialsSection extends Component {
  handleTestimonial = () => {
    const $items = $('#quotes-slider .quote');
    const $originalRandomizedItems = $items.sort(() => {
      return 0.5 - Math.random()
    });
    let randomizedItems = $originalRandomizedItems.toArray();

    // Show the first quote now
    $(randomizedItems.pop()).addClass('quote-mover');

    setInterval(() => {
      const $currentItem = $items.filter('.quote-mover');

      // If no items left, get original randomized array
      if (randomizedItems.length === 0) {
        randomizedItems = $originalRandomizedItems.toArray();
      }
      const $nextItem = $(randomizedItems.pop());

      $currentItem.removeClass('quote-mover');
      $nextItem.addClass('quote-mover');
    }, 5000);
  };

  componentDidMount() {
    this.handleTestimonial();
  }

  render() {
    return (
      <section className='testimonials'>
        <div className='quotes' id="quotes-slider">

          <div className='quote' id="quote1">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“Since I have placed the Awair in our apartment it has helped us gain<br />
                   IMMENSE insight as to how our behavior affects our air quality.”</p>
                <div className='name'>Nico</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote2">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaTwitter size='1.5em' /></span>
                <p>“Awair saved my kitchen and I from potential<br />
                   doom. Awair is my best recent purchase!”</p>
                <div className='name'>Adam S.</div>
                <div className='place'>Twitter</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote3">
            <div className='quote-text'>
              <div className='testimonial'>
                <p>“An air monitoring solution for all consumers.”</p>
                <img src={testimonialsRc} alt='recode' />
              </div>
            </div>
          </div>

          <div className='quote' id="quote4">
            <div className='quote-text'>
              <div className='testimonial'>
                <p>“Awair helps keep your home in the clear.”</p>
                <img src={testimonialsNbc} alt='nbcnews' />
              </div>
            </div>
          </div>

          <div className='quote' id="quote5">
            <div className='quote-text'>
              <div className='testimonial'>
                <p>“Awair takes note of your particular health issues<br />
                   and send you related suggestions so you’ll feel better.”</p>
                <img src={testimonialsCnet} alt='cnet' />
              </div>
            </div>
          </div>

          <div className='quote' id="quote6">
            <div className='quote-text'>
              <div className='testimonial'>
                <p>“Awair helps users actually do something about their air quality.”</p>
                <img src={testimonialsYa} alt='yahoo' />
              </div>
            </div>
          </div>

          <div className='quote' id="quote7">
            <div className='quote-text'>
              <div className='testimonial'>
                <p>“Awair tracks the elements in the air that will<br />
                   have an impact on your health and how you feel.”</p>
                <img src={testimonialsBr} alt='britco' />
              </div>
            </div>
          </div>

          <div className='quote' id="quote8">
            <div className='quote-text'>
              <div className='testimonial'>
                <p>“With the simple, almost mid-century design and<br />
                   the use of wood, the Awair is quite the beauty.”</p>
                <img src={testimonialsTc} alt='tc' />
              </div>
            </div>
          </div>

          <div className='quote' id="quote9">
            <div className='quote-text'>
              <div className='testimonial'>
                <p>“Awair helps you create the best air quality situation inside your house.”</p>
                <img src={testimonialsPsfk} alt='psfk' />
              </div>
            </div>
          </div>

          <div className='quote' id="quote10">
            <div className='quote-text'>
              <div className='testimonial'>
                <p>“Awair provides insights into the air quality around you.”</p>
                <img src={testimonialsVb} alt='venturebeat' />
              </div>
            </div>
          </div>

          <div className='quote' id="quote11">
            <div className='quote-text'>
              <div className='testimonial'>
                <p>“Awair helps you breathe easier by tracking air quality.”</p>
                <img src={testimonialsEn} alt='engadget' />
              </div>
            </div>
          </div>

          <div className='quote' id="quote12">
            <div className='quote-text'>
              <div className='testimonial'>
                <p>“Helps you change your behavior, based on what’s important to you.”</p>
                <img src={testimonialsDw} alt='dwell' />
              </div>
            </div>
          </div>

          <div className='quote' id="quote13">
            <div className='quote-text'>
              <div className='testimonial'>
                <img src={testimonialsZen} alt='zendesk' />
                <p>“I feel like a little Awair evangelist<br />
                   out here, and I’m getting lots of interest.”</p>
                <div className='name'>Mark D.</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote14">
            <div className='quote-text'>
              <div className='testimonial'>
                <img src={testimonialsZen} alt='zendesk' />
                <p>“Awair is the best air quality monitor<br />
                   I’ve tried… keep up the good work!!!”</p>
                <div className='name'>Alexi A.</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote15">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaTwitter size='1.5em' /></span>
                <p>“As an asthmatic, it’s super helpful to be<br />
                   able to improve indoor air quality w/ data.”</p>
                <div className='name'>Well R.</div>
                <div className='place'>Twitter</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote16">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaFacebook size='1.5em' /></span>
                <p>“It’s a gorgeous product, no doubt. But what it does is truly beautiful.”</p>
                <div className='name'>Jimbo K.</div>
                <div className='place'>Facebook</div>
              </div>
            </div>
          </div>


          <div className='quote' id="quote17">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“I followed a few of Awair’s recommendations and now the nursery is safe again.”</p>
                <div className='name'>Omaree R.</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote18">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“Love how easy it is to track the air quality<br />
                   of my home and how personalized it is to me.”</p>
                <div className='name'>Laura Li</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote19">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“Beautiful design, awesome device. You can have a<br />
                   complete idea about the air quality in your house.”</p>
                <div className='name'>Sotirios P.</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote20">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“I now have tools to measure so that I can improve<br />
                   the quality of my air and thus my life. Invaluable.”</p>
                <div className='name'>Julius T.</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote21">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“I like the tips in the app about how to lower<br />
                   VOCs and dust, as we have allergies to these.”</p>
                <div className='name'>Nodewalker</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote22">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“The device is very nicely made, small and stylish and feels good quality.”</p>
                <div className='name'>Mr. Mick</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote23">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“The app cards are great. They give<br />
                   hands-on recommendations and quite useful.”</p>
                <div className='name'>Jesse</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote24">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>I’m considering getting a couple more for the<br />
                   living room and the nursery. Worth the money.”</p>
                <div className='name'>Jesse</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote25">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“Super sleek design, I put this in my baby's room.”</p>
                <div className='name'>Lusi F.</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote26">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“Awair is quite a cool home/office device to have.”</p>
                <div className='name'>Cheolhong</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote27">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“Minimalist design that matches any household!”</p>
                <div className='name'>Laura</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote28">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“I’m using Awair to ensure our twins have<br />
                   a healthy, clean and safe environment.”</p>
                <div className='name'>L. Kelly</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote29">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“For my home, I see the Awair as the best device for my money.”</p>
                <div className='name'>Jeff T.</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote30">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“My wife has allergies and asthma and I can literally<br />
                   see her symptoms worsen as the bar graphs go up.”</p>
                <div className='name'>Jesus D.</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote31">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“The insights are helping us make changes to make our home healthier.”</p>
                <div className='name'>Adrian B.</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote32">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“Some things like allergy attacks now make<br />
                   sense as you see the pollen/dust increase.”</p>
                <div className='name'>Paul D.</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote33">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“Allows me to know when the air filters are no longer doing their jobs.”</p>
                <div className='name'>Paul D.</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote34">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaFacebook size='1.5em' /></span>
                <p>“I paired my Awair unit to my in-duct air purifier and<br />
                   together they keep my indoor air clean and breathable.”</p>
                <div className='name'>Todd S.</div>
                <div className='place'>Facebook</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote35">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“THANK YOU for making our home a healthier place to live!”</p>
                <div className='name'>Brandon D.</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote36">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“Awair is awesome. The design is beautiful and the functionality is great.”</p>
                <div className='name'>Jackson R.</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote37">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“It's been really interesting to see how our air quality<br />
                   is and work to find ways to improve it. Love this product!”</p>
                <div className='name'>Sherri G.</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote38">
            <div className='quote-text'>
              <div className='testimonial'>
                <p> “Useful for helping your family sleep through the night or avoid the flu.”</p>
                <img src={testimonialsFa} alt='fatherly' />
              </div>
            </div>
          </div>

          <div className='quote' id="quote39">
            <div className='quote-text'>
              <div className='testimonial'>
                <p>“Offers tips to help improve your air situation<br />
                   that are actually useful and targeted.”</p>
                <img src={testimonialsLh} alt='lifehacker' />
              </div>
            </div>
          </div>

          <div className='quote' id="quote40">
            <div className='quote-text'>
              <div className='testimonial'>
                <p>“Awair’s wood and white design sets it apart from most other modern tech.”</p>
                <img src={testimonialsLh} alt='lifehacker' />
              </div>
            </div>
          </div>

          <div className='quote' id="quote41">
            <div className='quote-text'>
              <div className='testimonial'>
                <p>“Awair gives a much more intuitive, complete, and immediate<br />
                   breakdown of air quality that you’ll actually want to act on.”</p>
                <img src={testimonialsLh} alt='lifehacker' />
              </div>
            </div>
          </div>

          <div className='quote' id="quote42">
            <div className='quote-text'>
              <div className='testimonial'>
                <p>“Allergy sufferers will appreciate you’re thinking about their health”</p>
                <img src={testimonialsDm} alt='designmilk' />
              </div>
            </div>
          </div>

          <div className='quote' id="quote43">
            <div className='quote-text'>
              <div className='testimonial'>
                <p>“Giving a gift to visually understand the importance<br />
                   of breathing fresh air is a great idea”</p>
                <img src={testimonialsWt} alt='washtimes' />
              </div>
            </div>
          </div>

          <div className='quote' id="quote44">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaInstagram size='1.5em' /></span>
                <p>“It’s so good! Not gonna lie, I’ve been a bit obsessed.”</p>
                <div className='name'>Jennifer Y.</div>
                <div className='place'>Instagram</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote45">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaTwitter size='1.5em' /></span>
                <p>“Really impressed...<br />
                   proud for it to essentially be the only thing on my nightstand with my phone.”</p>
                <div className='name'>Aaron N.</div>
                <div className='place'>Twitter</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote46">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“This device helps me keep my family and myself safe in a world filled with toxins.”</p>
                <div className='name'>James H.</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote47">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“My child has allergies that can lead to breathing problems,<br />
                   and the Awair has become an essential device in our home.”</p>
                <div className='name'>Andrew K.</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

          <div className='quote' id="quote48">
            <div className='quote-text'>
              <div className='testimonial'>
                <span><FaAmazon size='1.5em'/></span>
                <p>“My wife was convinced we needed a $$$ fancy air cleaner in our new house.<br />
                   Awair says our IAQ is very good!”</p>
                <div className='name'>R. F.</div>
                <div className='place'>Amazon</div>
              </div>
            </div>
          </div>

        </div>
      </section>
    );
  }
}

export default TestimonialsSection;


// WEBPACK FOOTER //
// ./src/app/components/organisms/TestimonialsSection/TestimonialsSection.js